import React from "react";
import { FormattedMessage } from "react-intl";
const PastTransactions = (props) => {
  const transactions = props.transactions;
  return (
    <div className="border-top mt-4 pt-3">
      <h4>
        <strong>
          <FormattedMessage
            id="billpay.past-transaction"
            defaultMessage="Past Transactions"
          />
        </strong>
      </h4>
      {transactions.map((item, index) => {
        return (
          <div
            className="row border-bottom mt-4 mb-4 pb-3"
            key={`transaction${index}`}
          >
            <div className="col-md-10 col-12">
              <div>
                <p className="text-secondary">
                  {item.provider_name} <br />
                  {item.order_number} <br />
                  {item.recent_transaction_message}
                </p>
              </div>
            </div>
            <div className="col-md-2 col-12">
              {item.status === 3 || item.status === 5 || item.status === 6 ? (
                <button
                  type="button"
                  className="btn btn-white winds-link-color repeat-btn"
                  onClick={() => props.repeat(item)}
                >
                  <FormattedMessage
                    id="billpay.repeat"
                    defaultMessage="Repeat"
                  />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-white winds-link-color repeat-btn"
                  onClick={() => props.repeat(item)}
                >
                  <FormattedMessage id="billpay.retry" defaultMessage="Retry" />
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PastTransactions;
